import {useEffect, useReducer} from "react";

import * as api from "../../../services/api";
import {useGlobalState} from "../../../GlobalState";


const useSmtpOptions = () => {
    const [state, updateSate] = useReducer(
        (state, partialState) => ({...state, ...partialState}),
        {value: null, isLoading: true, isUpdating: false}
    );

    const {updateSettings} = useGlobalState();

    const update = async (data) => {
        updateSate({isUpdating: true});
        try{
            await updateSettings({smtpOptions: data});
            updateSate({value: data, isUpdating: false});
        }catch(e){
            updateSate({isUpdating: false});
            throw e;
        }
    }

    useEffect(
        () => {
           const innerLoad = async () => {
               const smtpOptions = await api.RequestContract.getSmtpOptions();
               updateSate({value: smtpOptions, isLoading: false});  // TODO add a mapper
           }
           innerLoad();
        },
        []  // eslint-disable-line react-hooks/exhaustive-deps
    )

    return {
        ...state,
        update
    }
}

export default useSmtpOptions;